import { useCallback } from 'react'

import LoyaltySocietePointsFilterGroup from 'loyalty/components/LoyaltySocietePointsFilterGroup'
import useLoyaltyBurnExperiment from 'loyalty/hooks/useLoyaltyBurnExperiment'
import { deleteSearchParams, setSearchParamValue } from 'lib/url/searchUrlUtils'
import type { FilterControlChangeHandler } from './HotelSearchPageFilterPane'

interface Props {
  filters: App.OfferListFilters
  searchParams: string
  currentHash: string
  onFilterChange: FilterControlChangeHandler
}

function HotelSearchSocieteFilters({ filters, searchParams, currentHash, onFilterChange }: Props) {
  const { isAnyVariant: isBurnEnabled } = useLoyaltyBurnExperiment()
  const viewPriceInPoints = !!filters.viewPriceInPoints

  const handleViewPriceInPointsChange = useCallback((nextViewPriceInPoints: boolean) => {
    const newSearchParams = nextViewPriceInPoints
      ? setSearchParamValue(searchParams, 'viewPriceInPoints', 'true')
      : deleteSearchParams(searchParams, 'viewPriceInPoints')
    onFilterChange({ search: newSearchParams, hash: currentHash })
  }, [searchParams, currentHash, onFilterChange])

  if (!isBurnEnabled) {
    return null
  }

  return (
    <LoyaltySocietePointsFilterGroup
      skipBurnExperiment
      viewPriceInPoints={viewPriceInPoints}
      onViewPriceInPointsChange={handleViewPriceInPointsChange}
    />
  )
}

export default HotelSearchSocieteFilters
